import {
  createFayeClient,
  createLazyConnection,
  subscribeToChannel,
} from './fayeClient'
import { getRealtimeInfo } from './realtimeInfo'

type RealtimePrivacy = 'public' | 'private'

const initRealtimeConnection = async () => {
  const { realtimeDomain } = await getRealtimeInfo()

  // needs a wrapper because the Faye Client is thenable
  return { client: createFayeClient({ url: realtimeDomain }) }
}

const getRealtimeConnection = createLazyConnection(initRealtimeConnection)

const subscribe = async (
  privacy: RealtimePrivacy,
  channel: `/${string}`,
  callback: (message: unknown) => unknown
) => {
  const { client } = await getRealtimeConnection()
  const { publicChannelId, privateChannelId } = await getRealtimeInfo()

  const channelId = privacy === 'public' ? publicChannelId : privateChannelId

  if (channelId === '') {
    throw new Error(`No ${privacy} realtime channel is available for this role`)
  }

  return subscribeToChannel(client, channelId + channel, callback)
}

export { subscribe }
export type { RealtimePrivacy }
